"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreators = {
    requestSupportedFunction: function () { return function (dispatch, getState) {
        var appState = getState();
        var errorMessage = '';
        var isShowAlert = false;
        if (localStorage.getItem('FOCUSONE_API_GATEWAY')) {
            fetch("/v1/get-supported-function", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('FOCUSONE_API_GATEWAY'),
                },
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                console.log(data.supported_function);
                if (data && data.message) {
                    isShowAlert = true;
                    console.log(data.message);
                    try {
                        var obj = JSON.parse(data.message);
                        errorMessage = obj.message;
                    }
                    catch (err) {
                        errorMessage = data.message;
                    }
                }
                else {
                    if (data && data != undefined && data.supported_function != undefined) {
                        data.supported_function.sort(function (a, b) {
                            var x = a.dll_name.toLowerCase();
                            var y = b.dll_name.toLowerCase();
                            if (x == y) {
                                return 0;
                            }
                            return x < y ? -1 : 1;
                        });
                    }
                }
                console.log(isShowAlert);
                dispatch({ type: 'RECEIVE_SUPPORTED_FUNCTION', model: data.supported_function ? data.supported_function : [], errorMessage: errorMessage, isShowAlert: isShowAlert });
            })
                .then(function (error) {
                console.log(error);
            });
            dispatch({ type: 'REQUEST_SUPPORTED_FUNCTION' });
        }
    }; },
    clearAlert: function () { return function (dispatch, getState) {
        dispatch({ type: 'CLEAR_ALERT', errorMessage: '', isShowAlert: false });
    }; }
};
var unloadedState = { model: [], isLoading: false, errorMessage: "", isShowAlert: false };
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_SUPPORTED_FUNCTION':
            return {
                model: state.model,
                isLoading: true,
                errorMessage: state.errorMessage,
                isShowAlert: state.isShowAlert
            };
        case 'RECEIVE_SUPPORTED_FUNCTION':
            return {
                model: action.model,
                isLoading: false,
                errorMessage: action.errorMessage,
                isShowAlert: action.isShowAlert
            };
        case 'CLEAR_ALERT':
            return {
                model: state.model,
                isLoading: false,
                errorMessage: action.errorMessage,
                isShowAlert: action.isShowAlert
            };
        default: return state;
    }
};
//# sourceMappingURL=SupportedFunction.js.map